import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';

import runtimeConfig from '@/common/runtime-config';

import store from '@/store/index';

const connection = new HubConnectionBuilder()
  .withUrl(runtimeConfig.apiBaseUrl + '/message-hub', {
    accessTokenFactory: () => store.getters['auth/oidc/getAccessToken'] || '',
  })
  .configureLogging(LogLevel.Information)
  .build();

if ('Notification' in window) {
  if (Notification && Notification.permission !== 'granted') {
    console.log('Request notification permissions');
    Notification.requestPermission();
  }
} else {
  // API not supported
}

export default connection;
